import {
  SENTIDOS,
  TRAZAS,
  ACTUACION_ELEMENTOS_SEÑALIZACION_BALIZAMIENTO_CONTENCION,
  ELEMENTOS_SEÑALIZACION_BALIZAMIENTO,
  UNIDADES
} from './selectOptions'
import TYPES from '../../../../core/assets/assetTypes'
import comunIdentificacionFormFields from './comunIdentificacionFormFields'
import comunValidacionFormFields from './comunValidacionFormFields'

export const identificacion = (workOrderFragment, familyFragment) => [
  ...comunIdentificacionFormFields(
    workOrderFragment,
    'elementosSeñalizacionBalizamiento',
    familyFragment,
    [
      TYPES.SENALIZACION_HORIZONTAL,
      TYPES.SENALIZACION_VERTICAL,
      TYPES.BALIZAMIENTO
    ]
  ),

  {
    label: 'Comentarios',
    type: 'String',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'elementosSeñalizacionBalizamiento',
      familyFragment,
      'identificacion',
      'comentarios'
    ]
  }
]

export const inspeccion = (workOrderFragment, familyFragment) => [
  {
    label: 'Trabajos programados',
    type: 'Checkbox',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'elementosSeñalizacionBalizamiento',
      familyFragment,
      'inspeccion',
      'trabajosProgramados'
    ]
  },

  {
    label: 'Observaciones',
    type: 'String',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'elementosSeñalizacionBalizamiento',
      familyFragment,
      'inspeccion',
      'observaciones'
    ]
  }
]

export const ejecucion = (workOrderFragment, familyFragment) => [
  {
    label: 'PK Inicio',
    type: 'PK',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'elementosSeñalizacionBalizamiento',
      familyFragment,
      'ejecucion',
      'pkInicio'
    ]
  },

  {
    label: 'PK Fin',
    type: 'PK',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'elementosSeñalizacionBalizamiento',
      familyFragment,
      'ejecucion',
      'pkFin'
    ]
  },

  {
    label: 'Sentido',
    type: 'SimpleSelect',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'elementosSeñalizacionBalizamiento',
      familyFragment,
      'ejecucion',
      'sentido'
    ],
    meta: {
      options: SENTIDOS
    }
  },

  {
    label: 'Traza',
    type: 'SimpleSelect',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'elementosSeñalizacionBalizamiento',
      familyFragment,
      'ejecucion',
      'traza'
    ],
    meta: {
      options: TRAZAS
    }
  },

  {
    label: 'Actuación',
    type: 'SimpleSelect',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'elementosSeñalizacionBalizamiento',
      familyFragment,
      'ejecucion',
      'actuacion'
    ],
    meta: {
      options: ACTUACION_ELEMENTOS_SEÑALIZACION_BALIZAMIENTO_CONTENCION
    }
  },

  {
    label: 'Elementos',
    type: 'SimpleSelect',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'elementosSeñalizacionBalizamiento',
      familyFragment,
      'ejecucion',
      'elementos'
    ],
    meta: {
      options: ELEMENTOS_SEÑALIZACION_BALIZAMIENTO
    }
  },

  {
    label: 'Medición',
    type: 'Number',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'elementosSeñalizacionBalizamiento',
      familyFragment,
      'ejecucion',
      'medicion'
    ]
  },

  {
    label: 'Unidad',
    type: 'SimpleSelect',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'elementosSeñalizacionBalizamiento',
      familyFragment,
      'ejecucion',
      'unidad'
    ],
    meta: {
      options: UNIDADES
    }
  },

  {
    label: 'Trabajos programados',
    type: 'Checkbox',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'elementosSeñalizacionBalizamiento',
      familyFragment,
      'ejecucion',
      'trabajosProgramados'
    ]
  },

  {
    label: 'Observaciones',
    type: 'String',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'elementosSeñalizacionBalizamiento',
      familyFragment,
      'ejecucion',
      'observaciones'
    ]
  },

  {
    label: 'Fotos antes',
    type: 'Documents',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'elementosSeñalizacionBalizamiento',
      familyFragment,
      'ejecucion',
      'antesFotos'
    ],
    meta: { isPhotos: true }
  },

  {
    label: 'Fotos despues',
    type: 'Documents',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'elementosSeñalizacionBalizamiento',
      familyFragment,
      'ejecucion',
      'despuesFotos'
    ],
    meta: { isPhotos: true }
  }
]

export const validacion = comunValidacionFormFields(
  'elementosSeñalizacionBalizamiento'
)
